import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import FilterChip from '../base/FilterChip';
import Dropdown, { DropdownProps } from '../Dropdown';
import { DropdownMenuOptionItem } from '../DropdownMenu';
import { Div } from '../helpers/StyledUtils';
import { FilterComponent } from './FilterComponents';
import { FiltersContext } from './Filters';
export const MoreFiltersMenu: React.FC<{
  filters: FilterComponent[];
} & Partial<Omit<DropdownProps, 'children'>>> = t0 => {
  const $ = _c(16);
  let filters;
  let props;
  if ($[0] !== t0) {
    ({
      filters,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = filters;
    $[2] = props;
  } else {
    filters = $[1];
    props = $[2];
  }
  const [selected_filter, setSelectedFilter] = useState(null);
  const {
    formik
  } = useContext(FiltersContext);
  const t1 = selected_filter ? selected_filter.width || 300 : 300;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      min: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props) {
    t3 = opened_0 => {
      setSelectedFilter(null);
      if (props.onToggle) {
        props.onToggle(opened_0);
      }
    };
    $[5] = props;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== filters || $[8] !== formik || $[9] !== selected_filter) {
    t4 = toggle => selected_filter && selected_filter.Component ? <selected_filter.Component key={selected_filter.filter_key} label={selected_filter.label} name={selected_filter.form_name} filters={filters} in_dropdown={true} {...selected_filter.component_props as any} onSubmit={() => {
      formik.handleSubmit();
      setSelectedFilter(null);
      toggle(false);
    }} onReset={formik.resetForm} onBack={() => setSelectedFilter(null)} /> : <Div p={1}>{filters.map(f => <DropdownMenuOptionItem key={f.label} label={f.label} icon={f.icon} action_icon="add_circle" onClick={() => setSelectedFilter(f)} />)}</Div>;
    $[7] = filters;
    $[8] = formik;
    $[9] = selected_filter;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <Dropdown {...props} renderToggle={_temp} portal={true} parent_width={t2} onToggle={t3} placement="bottom-end">{t4}</Dropdown>;
    $[11] = props;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
function _temp(opened, handleToggle) {
  return <FilterChip label="More filters" m={{
    y: 1
  }} icon="add" active={opened} dashed={true} onClick={() => handleToggle(true)} />;
}